import { useContext } from 'react'
import OnboardingContext from '@/context/OnboardingContext'

export default function useOnboarding() {
  const context = useContext(OnboardingContext)
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider')
  }
  return context
}
